import React from "react";
import { C } from "../../core/constants";

export const NAV_ICON_CLASS = "ecliptica-nav-icon";

/** Prefer monochrome symbol glyphs over emoji presentation (esp. iOS/iPadOS). */
export function navIconText(icon) {
  if (typeof icon !== "string" || !icon) return icon;
  if (/[\uFE0E\uFE0F]/.test(icon)) return icon;
  return `${icon}\uFE0E`;
}

export function getNavItemStyles({ active, acc, variant = "sidebar" }) {
  if (variant === "bottom") {
    return {
      button: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
        flex: "1 1 0",
        minWidth: 0,
        minHeight: 44,
        padding: "6px 4px",
        border: "none",
        borderRadius: 10,
        cursor: "pointer",
        background: active ? `${acc.primary}18` : "transparent",
        color: active ? acc.primary : C.textMuted,
        fontFamily: "'DM Sans',sans-serif",
        fontSize: 10,
        fontWeight: active ? 600 : 400,
        textAlign: "center",
        transition: "all 0.2s",
      },
      icon: {
        opacity: active ? 1 : 0.65,
      },
      label: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "100%",
        lineHeight: 1.2,
      },
    };
  }

  return {
    button: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      width: "100%",
      padding: "11px 14px",
      borderRadius: 10,
      border: "none",
      cursor: "pointer",
      background: active ? `linear-gradient(90deg,${acc.primary}22,transparent)` : "transparent",
      color: active ? acc.primary : C.textSecondary,
      fontFamily: "'DM Sans',sans-serif",
      fontSize: 14,
      fontWeight: active ? 500 : 400,
      borderLeft: active ? `2px solid ${acc.primary}` : "2px solid transparent",
      marginBottom: 2,
      textAlign: "left",
      transition: "all 0.2s",
    },
    icon: {
      opacity: active ? 1 : 0.6,
    },
    label: {},
  };
}

export default function NavItemButton({
  item,
  active,
  acc,
  label,
  onClick,
  variant = "sidebar",
  showLabel = true,
}) {
  const styles = getNavItemStyles({ active, acc, variant });

  return (
    <button type="button" onClick={onClick} style={styles.button} aria-current={active ? "page" : undefined}>
      <span className={NAV_ICON_CLASS} style={styles.icon} aria-hidden>
        {navIconText(item.icon)}
      </span>
      {showLabel && <span style={styles.label}>{label}</span>}
    </button>
  );
}
